import { render, staticRenderFns } from "./FormUser.vue?vue&type=template&id=7f0c585a&"
import script from "./FormUser.vue?vue&type=script&lang=js&"
export * from "./FormUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports